// Единый словарь цветов предметов: используется и в карточке (свотчи),
// и в фильтрах (поиск по цвету). Slug'и совпадают с тегами категории `color`,
// которые проставляет scraper/src/classify.ts.

export interface ColorDef {
  slug: string;
  name: string;
  hex: string;
}

export const COLORS: ColorDef[] = [
  { slug: 'red', name: 'Красный', hex: '#ef4444' },
  { slug: 'orange', name: 'Оранжевый', hex: '#f97316' },
  { slug: 'yellow', name: 'Жёлтый', hex: '#eab308' },
  { slug: 'gold', name: 'Золотой', hex: '#d4af37' },
  { slug: 'green', name: 'Зелёный', hex: '#22c55e' },
  { slug: 'cyan', name: 'Бирюзовый', hex: '#06b6d4' },
  { slug: 'blue', name: 'Синий', hex: '#3b82f6' },
  { slug: 'purple', name: 'Фиолетовый', hex: '#a855f7' },
  { slug: 'pink', name: 'Розовый', hex: '#ec4899' },
  { slug: 'brown', name: 'Коричневый', hex: '#92400e' },
  { slug: 'white', name: 'Белый', hex: '#f5f5f4' },
  { slug: 'gray', name: 'Серый', hex: '#78716c' },
  { slug: 'black', name: 'Чёрный', hex: '#0c0a09' },
];

export const COLOR_HEX: Record<string, string> = Object.fromEntries(
  COLORS.map((c) => [c.slug, c.hex]),
);
